import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

export const TextContent = styled(Group)`
  min-width: 0;
`

export const TitleRow = styled(Group)`
  min-width: 0;

  > :first-child {
    min-width: 0;
  }

  > button {
    flex-shrink: 0;
  }
`

export const OptionTitle = styled(BodyText)`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const OptionDescription = styled(BodyText)`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const TrailingControl = styled.div`
  display: flex;
  align-self: center;
  flex-shrink: 0;
  align-items: center;
`
